<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<p class="text-center text-3xl font-hairline text-blue-500 mb-4">{{ 'converKazEnt' | translate }}:</p>
<form [formGroup]="applicationForm">
  <div class="flex mb-4">
    <div class="w-1/5 h-1 bg-blue-300 mt-4">
    </div>
    <div class="w-3/5 text-center text-3xl font-hairline uppercase tracking-widest">
      {{ 'PersonalData' | translate }}
    </div>
    <div class="w-1/5 h-1 bg-blue-300 mt-4">
    </div>
  </div>
  <div class="flex py-1">
    <div class="w-1/3">
      {{ 'IIN' | translate }}
    </div>
    <div class="w-2/3">
      <input
        [mask]="iin"
        formControlName="iin"
        class="border w-1/2 h-6 rounded"
        type="text">
    </div>
  </div>
  <div class="flex py-3">
    <div class="w-1/3">
      {{ 'Surname' | translate }}
    </div>
    <div class="w-2/3">
      <input
        formControlName="lastname"
        class="border w-1/2 h-6 rounded"
        type="text">
    </div>
  </div>
  <div class="flex py-3">
    <div class="w-1/3">
      {{ 'Name' | translate }}
    </div>
    <div class="w-2/3">
      <input
        formControlName="firstname"
        class="border w-1/2 h-6 rounded"
        type="text">
    </div>
  </div>
  <div class="flex py-3">
    <div class="w-1/3">
      {{ 'Patronymic' | translate }}
    </div>
    <div class="w-2/3">
      <input
        formControlName="patronymic"
        class="border w-1/2 h-6 rounded"
        type="text">
    </div>
  </div>
  <div class="flex py-3">
    <div class="w-1/3">
      {{ 'YourEmail' | translate }}
    </div>
    <div class="w-2/3">
      <input
        formControlName="email"
        class="border w-1/2 h-6 rounded"
        type="text">
    </div>
  </div>
  <div class="flex py-3">
    <div class="w-1/3">
      {{ 'PhoneNumber' | translate }}
    </div>
    <div class="w-2/3">
      <input
        [mask]="phone"
        formControlName="phoneNumber"
        class="border w-1/2 h-6 rounded"
        type="text">
    </div>
  </div>
  <div class="flex mb-4 ">
    <div class="w-1/5 h-1 bg-blue-300 mt-4">
    </div>
    <div class="w-3/5 text-center text-3xl font-hairline uppercase tracking-widest">
      {{ 'paromConvert' | translate }}
    </div>
    <div class="w-1/5 h-1 bg-blue-300 mt-4">
    </div>
  </div>
  <!--               -->
  <!--  таблица ЕНТ  -->
  <!--               -->
  <div class="flex">
    <div class="w-1/2">
      <p class="font-bold">{{ 'uslovieConvert' | translate }}</p>
      <li class="text-blue-600">
        {{ 'actualSert' | translate }}
      </li>
      <p>
        {{ 'srokSert' | translate }}
      </p>
      <li class="text-blue-600">
        {{ 'profSubj' | translate }}
      </li>
      <p>
        {{ 'kaz' | translate }}
      </p>
    </div>
    <table class="w-1/2">
      <thead>
      <tr>
        <th></th>
        <th>{{ 'IKT' | translate }}</th>
        <th>{{ 'numberCert' | translate }}</th>
        <th>{{ 'TestDate' | translate }}</th>
        <th>{{ 'ballSumm' | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of entList; let i = index">
        <td>
          <input
            type="radio"
            name="entCertificateSelection" [id]="'ent-row-' + i"
            [checked]="item.selected"
            (change)="onEntSelectionChange(item)">
        </td>
        <td>{{ item.studentTestId }}</td>
        <td>{{ item.certificateId }}</td>
        <td>{{ item.testDate }}</td>
        <td>{{ item.score }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <!--                   -->
  <!--  таблица казтест  -->
  <!--                   -->
  <div class="flex mt-5">
    <div class="w-1/2">
      <p class="font-bold">{{ 'uslovieConvert' | translate }}</p>
      <li class="text-blue-600">
        {{ 'actualSert' | translate }}
      </li>
      <p>
        {{ 'actualSrok' | translate }}
      </p>
      <li class="text-blue-600">
        {{ 'b1' | translate }}
      </li>
      <p *ngIf="translate.currentLang == 'ru'">
        Аудирование - 10 баллов (50%);
        <br> Чтение - 20 баллов (50%);
        <br> Письмо - 25 баллов (50%);
        <br> Говорение - 25 баллов (50%).
      </p>
      <p *ngIf="translate.currentLang == 'kz'">
        Тыңдалым — 10 балл (50%);
        <br> Оқылым - 20 балл (50%);
        <br> Жазылым - 25 балл (50%);
        <br> Айтылым - 25 балл (50%).
      </p>
    </div>
    <table class="w-1/2">
      <thead>
      <tr>
        <th></th>
        <th>{{ 'IKT' | translate }}</th>
        <th>{{ 'numberCert' | translate }}</th>
        <th>{{ 'TestDate' | translate }}</th>
        <th>{{ 'Level' | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of kaztestList; let i = index">
        <td>
          <input
            type="radio"
            name="kaztestCertificateSelection" [id]="'kaztest-row-' + i"
            [checked]="item.selected"
            (change)="onKaztestSelectionChange(item)">
        </td>
        <td>{{ item.studentTestId }}</td>
        <td>{{ item.certificateId }}</td>
        <td>{{ item.testDate }}</td>
        <td>{{ item.levelCode }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <button class="btn btn-primary border-green-500 bg-green-500 h-10 w-1/4" *ngIf="!convertDataList"
          (click)="getIsConverted()">
    {{ 'checkConv' | translate }}
  </button>
  <!--                     -->
  <!--  таблица предметов  -->
  <!--                     -->
  <div *ngIf="subjList.length > 0" class="flex mt-5">
    <div class="w-1/2">
      <p *ngIf="translate.currentLang == 'kz'">
        Аударылған ҰБТ сертификаты <br> келесі нәтижелермен болады:
      </p>
      <p *ngIf="translate.currentLang == 'ru'">
        Сконвертированный сертификат ЕНТ <br> будет с результатами:
      </p>
    </div>
    <table class="w-1/2">
      <thead>
      <tr>
        <td class="text-center font-bold">№</td>
        <td class="text-center font-bold">{{ 'nameDisc' | translate }}</td>
        <td class="text-center font-bold">Балл</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let subject of subjList; let i = index">
        <td>{{ subject.ord }}</td>
        <td class="text-left">
          <span *ngIf="translate.currentLang == 'kz'">{{ subject.name.kk }} </span>
          <span *ngIf="translate.currentLang == 'ru'">{{ subject.name.ru }} </span>
        </td>
        <td>{{ subject.score }}</td>
      </tr>
      <tr>
        <td colspan="2" class="total-label text-right font-bold">{{ 'obshball' | translate }}</td>
        <td>{{ totalScore }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="grid mt-3">
    <div class="flex flex-col gap-y-4">
      <div class="flex items-center" *ngIf="subjList">
        <button class="btn btn-primary w-1/4" *ngIf="subjList.length > 0 && !convertDataList"
                (click)="openConvert = true">
          {{ 'goConvert' | translate }}
        </button>
        <button class="btn btn-primary w-1/4" *ngIf="convertDataList" (click)="download()">
          {{ 'downloadFile' | translate }}
        </button>
        <button class="btn btn-primary h-10 w-1/4 ml-auto" [routerLink]="'/profile/history'">
          {{ 'Close' | translate }}
        </button>
      </div>
    </div>
  </div>
</form>
<div *ngIf="openWindow == true" class="overlay">
  <div class="modal-window">
    <div class="relative">
      <div class="modal-sub-header">
        {{ 'toHistory' | translate }}
      </div>
      <div (click)="closeModal()" class="text-red-500 absolute right-0 top-0 cursor-pointer font-bold">
        X
      </div>
    </div>
    <div class="text-center">
      <button class="btn btn-primary h-10 w-1/3" [routerLink]="'/profile/history'">
        {{ 'Yes' | translate }}
      </button>
      <button class="btn btn-primary h-10 w-1/3 ml-48 border-red-500 bg-red-500" (click)="closeModal()">
        {{ 'No' | translate }}
      </button>
    </div>
  </div>
</div>
<div *ngIf="openConvert == true" class="overlay">
  <div class="modal-window">
    <div class="relative">
      <div class="modal-sub-header">
        {{ 'convertBall' | translate }}
      </div>
      <div (click)="closeModalConvert()" class="text-red-500 absolute right-0 top-0 cursor-pointer font-bold">
        X
      </div>
    </div>
    <div class="text-center">
      <button class="btn btn-primary h-10 w-1/3" (click)="convert()">
        {{ 'Yes' | translate }}
      </button>
      <button class="btn btn-primary h-10 w-1/3 ml-48 border-red-500 bg-red-500" (click)="closeModalConvert()">
        {{ 'No' | translate }}
      </button>
    </div>
  </div>
</div>
